/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportCatalogCategory {
    getFixupPrototypeFunction() { return ReportCatalogCategory.fixupPrototype; }

    static newInstance(model: Partial<ReportCatalogCategory>): ReportCatalogCategory {
        let obj = Object.assign(new ReportCatalogCategory(), model);
        ReportCatalogCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportCatalogCategory>): ReportCatalogCategory {
        if (!model) return null;
        return ReportCatalogCategory.newInstance(<ReportCatalogCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportCatalogCategory) {
        if (!obj) return;

        models.ReportCatalogCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportCatalogCategory): boolean {
        Object.setPrototypeOf(obj, ReportCatalogCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.report_count === undefined) {
            this.report_count = 0;
        }
        if (this.sub_categories) {
            for (let val of this.sub_categories) {
                models.ReportCatalogSubCategory.fixupPrototype(val);
            }
        }
    }

    /**
     * Product category name
     */
    name: models.ReportProductCategory;

    /**
     * Number of reports in the category, including all of its sub-categories
     */
    report_count: number;

    /**
     * Sub-categories of the category
     */
    sub_categories: Array<models.ReportCatalogSubCategory>;

}
